import React from 'react';
import { Dropdown } from "semantic-ui-react";

import './clearableDropdown.style.css';
import 'semantic-ui-css/semantic.min.css';

const ClearableDropdown = ({
  placeHolder,
  header,
  changeHandler,
  inputOptions,
  selectedValue,
  clearable,
  disabled = false
}) => {

  return (
    <>
      {header && (
        <label className='dropdown-label'>
          {header}
        </label>
      )}
      <Dropdown
        className='dropdown'
        clearable={clearable}
        search
        selection
        placeholder={placeHolder}
        onChange={changeHandler}
        options={inputOptions}
        value={selectedValue}
        disabled={disabled}
      />
    </>
  );
};

export default ClearableDropdown;